export const getPlaylist = (playlisId, playlists) => playlists.find(({_id}) => _id === playlisId);